<template>
  <generic-modal :title="$t('neighbor')" ref="generic_modal" :is_wide="true">
    <div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("neighbor id") }}</label>
            <div class="control has-icons-left">
              <input class="input" type="text" v-model="meta.home_number" />
              <span class="icon is-small is-left">
                <i class="fa fa-home"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("active") }}</label>
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_is_active"
              name="chk_is_active"
              v-model="meta.is_active"
            />
            <label for="chk_is_active">{{ $t("is active") }}</label>
          </div>
        </div>
      </div>
      <div class="title is-5">{{ $t("resident") }}</div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control has-icons-left">
              <input class="input" type="text" v-model="meta.resident_name" />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("email") }}</label>
            <div class="control has-icons-left">
              <input class="input" type="text" v-model="meta.resident_email" />
              <span class="icon is-small is-left">
                <i class="fa fa-at"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("phone number") }}</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                v-model="meta.resident_phone_number"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-phone"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("receipt") }}</label>
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_send_receipt_to_resident"
              name="chk_send_receipt_to_resident"
              v-model="meta.send_receipt_to_resident"
            />
            <label for="chk_send_receipt_to_resident">{{
              $t("send receipt")
            }}</label>
          </div>
        </div>
      </div>

      <div class="title is-5">{{ $t("owner") }}</div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control has-icons-left">
              <input class="input" type="text" v-model="meta.owner_name" />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("email") }}</label>
            <div class="control has-icons-left">
              <input class="input" type="text" v-model="meta.owner_email" />
              <span class="icon is-small is-left">
                <i class="fa fa-at"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("phone number") }}</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                v-model="meta.owner_phone_number"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-phone"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("receipt") }}</label>
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_send_receipt_to_owner"
              name="chk_send_receipt_to_owner"
              v-model="meta.send_receipt_to_owner"
            />
            <label for="chk_send_receipt_to_owner">{{
              $t("send receipt")
            }}</label>
          </div>
        </div>
      </div>

      <div class="title is-5">{{ $t("co-owner") }}</div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control has-icons-left">
              <input class="input" type="text" v-model="meta.co_owner_name" />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("email") }}</label>
            <div class="control has-icons-left">
              <input class="input" type="text" v-model="meta.co_owner_email" />
              <span class="icon is-small is-left">
                <i class="fa fa-at"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("phone number") }}</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                v-model="meta.co_owner_phone_number"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-phone"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("receipt") }}</label>
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_send_receipt_to_co_owner"
              name="chk_send_receipt_to_co_owner"
              v-model="meta.send_receipt_to_co_owner"
            />
            <label for="chk_send_receipt_to_co_owner">{{
              $t("send receipt")
            }}</label>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t("photo") }}</label>
        <div class="control">
          <generic-uploader
            ref="generic_uploader"
            :idle_label="$t('drop photo here or click to upload')"
            endpoint_url="/gym_member/photo"
            @error="error_uploading"
            @success="success_uploading"
            :allow_multiple="false"
          />
        </div>
        <!-- <pre>{{ meta }}</pre> -->
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";

export default {
  name: "Gym_memberModal",
  components: {
    GenericModal,
    GenericUploader,
  },
  data() {
    return {
      meta: { settings: {} },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.home_number;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.$refs.generic_modal.show_modal();
      get("/neighbor", { uuid })
        .then((response) => {
          v.meta = response;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/neighbor", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/neighbor", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        // name: "",
        // phone_number: "",
        // email: "",
        settings: {},
      };
      v.error = "";
      v.$refs.generic_uploader.clear();
      // v.uuid = "";
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      let data = {
        file_id: rspnse.file.file_id,
        final_name: rspnse.final_name,
      };

      v.meta.settings.photo = data;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
